import {makeStyles} from "@material-ui/core"
import {ModernTheme} from "../../../../../theme/modern/tokens"

export default makeStyles((theme: ModernTheme) => ({
    pagekeys: {
        display: "flex",
        gap: "16px",
        justifyContent: "center",
        padding: "4px 0 2px",
        flexWrap: "wrap",
    },
    hint: {
        display: "inline-flex",
        alignItems: "center",
        gap: "5px",
        font: `400 11px ${theme.modern.sans}`,
        color: theme.modern.ink3,
        whiteSpace: "nowrap",
    },
}))
